import Alpine from 'alpinejs';

Alpine.data("solutionFinder", (collectionUrl) => ({
  isStarted: false,
  productType: '',
  contamination: '',
  material: '',
  collectionUrl: collectionUrl || window.location.pathname,
  product_types: {},
  target_contaminants: {},
  target_materials: {},

  start() {
    fetch("https://rozone-01.myshopify.com/api/2026-04/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "ceb861b316aa8a52eebe7f3b0e6c8736",
      },
      body: JSON.stringify({
        query: `
          {
            collection(handle: "solution-finder") {
              handle
              products(first: 250) {
                filters {
                  id
                  label
                  values {
                    label
                    count
                  }
                }
              }
            }
          }
        `,
      }),
    }).then((response) => response.json())
      .then((data) => {
        for (let product of data.data.collection.products.filters) {
          switch (product.id) {
            case "filter.p.product_type":
              this.product_types = product.values;
              break;
            case "filter.p.m.custom.target_contaminants":
              this.target_contaminants = product.values;
              break;
            case "filter.p.m.custom.target_materials":
              this.target_materials = product.values;
              break;
          }
        }
      })
      .catch((error) => console.error(error));
    this.isStarted = true;
  },

  submit() {
    const url = new URL(this.collectionUrl, window.location.origin);
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.delete('filter.p.m.custom.target_contaminants');
    url.searchParams.delete('filter.p.m.custom.target_materials');

    if (this.productType) {
      url.searchParams.append('filter.p.product_type', this.productType);
    }
    if (this.contamination) {
      url.searchParams.append('filter.p.m.custom.target_contaminants', this.contamination);
    }
    if (this.material) {
      url.searchParams.append('filter.p.m.custom.target_materials', this.material);
    }

    window.location.href = url.toString();
  }
}))